<div class="sidebar">
    <app-sidebar-header [title]="'extrasSidebar.hazmat.title.useCautionWhenPackingUp' | ibeadmin | async"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable low-contrast" #sidebar__body
		style="overflow: auto">
        <p>{{ 'extrasSidebar.hazmat.text.someEverydayProduct' | ibeadmin | async }}</p>

		<section class="info-prohibitions info-prohibitions--checked">
			<h2>{{ 'extrasSidebar.hazmat.text.prohibitedCheckedBaggage' | ibeadmin | async }}</h2>


			<div class="grid no-padding">
				<div [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']">
					<div class="info-prohibitions__title">
						<app-svg class="icon" svg="icons.svg#warning--corrosive" aria-hidden="true"
						[alt]="'extrasSidebar.hazmat.alt.warningCorrosiveMaterialIcon' | ibeadmin | async"></app-svg>
						<h6 class="title title-h6">{{ 'extrasSidebar.hazmat.text.corrosives' | ibeadmin | async }}</h6>
					</div>

					<ul class="bullet-list">
						<li>{{ 'extrasSidebar.hazmat.text.mercury' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.carBatteries' | ibeadmin | async }}</li>
					</ul>
				</div>

				<div [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']">
					<div class="info-prohibitions__title">
						<app-svg class="icon" svg="icons.svg#warning--radioactive" aria-hidden="true"
                        [alt]="'extrasSidebar.hazmat.alt.warningRadioactiveMaterialIcon' | ibeadmin | async"></app-svg>
						<h6 class="title title-h6">{{ 'extrasSidebar.hazmat.text.radioactive' | ibeadmin | async }}</h6>
					</div>

					<ul class="bullet-list">
						<li>{{ 'extrasSidebar.hazmat.text.medicinalIsotopes' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.otherIsotopesAvailableOnTheMarket' | ibeadmin | async }}</li>
					</ul>
				</div>
            
				<div [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']">
					<div class="info-prohibitions__title">
						<app-svg class="icon" svg="icons.svg#warning--battery" aria-hidden="true" [alt]="'extrasSidebar.hazmat.alt.warningBMaterialIcon' | ibeadmin | async">
						</app-svg>
						<h6 class="title title-h6">{{ 'extrasSidebar.hazmat.text.batteries' | ibeadmin | async }}</h6>
					</div>

					<ul class="bullet-list">
						<li>{{ 'extrasSidebar.hazmat.text.replacementLaptopComputerBatteries' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.replacementAudiovisualEquipmentBatteries' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.largeBatteries' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.alkalineBatteries' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.wetBatteries' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.otherTpesOfBatteryAvailableOnTheMarket' | ibeadmin | async }}</li>
					</ul>
				</div>

				<div [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']">
					<div class="info-prohibitions__title">
						<app-svg class="icon" svg="icons.svg#warning--flammable" aria-hidden="true"
                        [alt]="'extrasSidebar.hazmat.alt.warningFlammableMaterialIcon' | ibeadmin | async"></app-svg>
						<h6 class="title title-h6">{{ 'extrasSidebar.hazmat.text.flammables' | ibeadmin | async }}</h6>
					</div>

					<ul class="bullet-list">
						<li>{{ 'extrasSidebar.hazmat.text.propaneGas' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.butaneGas' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.petrol' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.methanol' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.magnesium' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.lighters' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.fireworks' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.torches' | ibeadmin | async }}</li>
					</ul>
				</div>

				<div [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']">
					<div class="info-prohibitions__title">
						<app-svg class="icon" svg="icons.svg#warning--toxic" aria-hidden="true"
                        [alt]="'extrasSidebar.hazmat.alt.warningToxicMaterialIcon' | ibeadmin | async"></app-svg>
						<h6 class="title title-h6">{{ 'extrasSidebar.hazmat.text.toxicOrInfectiousSubstances' | ibeadmin | async }}</h6>
					</div>

					<ul class="bullet-list">
						<li>{{ 'extrasSidebar.hazmat.text.ratPoison' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.infectedBlood' | ibeadmin | async }}</li>
					</ul>
				</div>

				<div [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']">
					<div class="info-prohibitions__title">
						<app-svg class="icon" svg="icons.svg#warning--oxidant" aria-hidden="true"
                        [alt]="'extrasSidebar.hazmat.alt.warningOxidantMaterialIcon' | ibeadmin | async"></app-svg>
						<h6 class="title title-h6">{{ 'extrasSidebar.hazmat.text.oxidantsAndOrganicPeroxides' | ibeadmin | async }}</h6>
					</div>

					<ul class="bullet-list">
						<li>{{ 'extrasSidebar.hazmat.text.bleach' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.carpaintTouchupKits' | ibeadmin | async }}</li>
					</ul>
				</div>

				<div [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']">
					<div class="info-prohibitions__title">
						<app-svg class="icon" svg="icons.svg#warning--fuelcomp" aria-hidden="true"
                        [alt]="'extrasSidebar.hazmat.alt.warningFuelMaterialIcon' | ibeadmin | async"></app-svg>
						<h6 class="title title-h6">{{ 'extrasSidebar.hazmat.text.fuel' | ibeadmin | async }}</h6>
					</div>

					<ul class="bullet-list">
						<li>{{ 'extrasSidebar.hazmat.text.carFuelSuppplySystemsContainedFuel' | ibeadmin | async }}</li>
					</ul>
				</div>

				<div [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']">
					<div class="info-prohibitions__title">
						<app-svg class="icon" svg="icons.svg#leisure_and_commodities--e_cigarrette" aria-hidden="true"
                        [alt]="'extrasSidebar.hazmat.alt.warningRadioactiveMaterialEcIcon' | ibeadmin | async"></app-svg>
						<h6 class="title title-h6">{{ 'extrasSidebar.hazmat.text.electronicCigarrettes' | ibeadmin | async }}</h6>
					</div>
				</div>
		
				<div [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']">
					<div class="info-prohibitions__title">
						<app-svg class="icon" svg="icons.svg#warning--explosives" aria-hidden="true"
                        [alt]="'extrasSidebar.hazmat.alt.warningExplosivesMaterialIcon' | ibeadmin | async"></app-svg>
						<h6 class="title title-h6">{{ 'extrasSidebar.hazmat.text.explosives' | ibeadmin | async }}</h6>
					</div>

					<ul class="bullet-list">
						<li>{{ 'extrasSidebar.hazmat.text.detonators' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.fuses' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.grenades' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.mines' | ibeadmin | async }}</li>
						<li>{{ 'extrasSidebar.hazmat.text.firearmsAndAmmunitionContainingExplosiveProjectiles' | ibeadmin | async }}</li>
					</ul>
				</div>

			</div>
		</section>


		<section class="info-prohibitions info-prohibitions--hand">
			<h2>{{ 'extrasSidebar.hazmat.text.prohibitedHandBaggage' | ibeadmin | async }}</h2>

            
			<p>{{ 'extrasSidebar.hazmat.text.yourHandLuggageCannotContainItems' | ibeadmin | async }}
			</p>

			<ul class="bullet-list">
				<li>{{ 'extrasSidebar.hazmat.text.gunsFirearmsAndOtherDevices' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.hazmat.text.ammunition' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.hazmat.text.neutralizingDevices' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.hazmat.text.sharpObjects' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.hazmat.text.workingTools' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.hazmat.text.bluntInstruments' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.hazmat.text.explosives' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.hazmat.text.incendiarySubstancesAndDevices' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.hazmat.text.liquidsAerosolsAndGels' | ibeadmin | async }}</li>
			</ul>
            
			<p class="info-prohibitions__description">{{ 'extrasSidebar.hazmat.text.electronicCigarrettesMayBeCarried' | ibeadmin | async }}<br>
				{{ 'extrasSidebar.hazmat.text.youAreRequiredToAsk' | ibeadmin | async }}</p>
		</section>
        

		<section class="info-prohibitions">
			<h2>{{ 'extrasSidebar.hazmat.text.penalties' | ibeadmin | async }}</h2>

			<p>{{ 'extrasSidebar.hazmat.text.carriageOfProhibitedItems' | ibeadmin | async }} <br>
				{{ 'extrasSidebar.hazmat.text.forMoreInformationOnBaggage' | ibeadmin | async }}
				<a class="link link--advance-search" href="javacsript:;" [attr.aria-label]="'extrasSidebar.hazmat.aria.goToContactTapPage' | ibeadmin | async"
				(click)="INDRA_gotoURL('externalURLs.contactTAP')" href="javascript:;" role="button">{{ 'extrasSidebar.hazmat.text.contactTAP' | ibeadmin | async }}</a> {{ 'extrasSidebar.hazmat.text.or' | ibeadmin | async }}
				<a class="link link--external link--advance-search" target="_blank" [attr.aria-label]="'extrasSidebar.hazmat.aria.goToSafeTravelPage' | ibeadmin | async"
				href="http://phmsa.dot.gov/safetravel" role="button">{{ 'extrasSidebar.hazmat.text.safetravel' | ibeadmin | async }}</a>,
				<a class="link link--external link--advance-search" target="_blank" [attr.aria-label]="'extrasSidebar.hazmat.aria.goToSafeTravelPage' | ibeadmin | async"
				href="http://www.tsa.gov/" role="button">{{ 'extrasSidebar.hazmat.text.tsaGov' | ibeadmin | async }}</a> {{ 'extrasSidebar.hazmat.text.or' | ibeadmin | async }}
				<a class="link link--external link--advance-search" target="_blank" [attr.aria-label]="'extrasSidebar.hazmat.aria.goToFaaPage' | ibeadmin | async"
				href="http://www.faa.gov/" role="button">{{ 'extrasSidebar.hazmat.text.faaGov' | ibeadmin | async }}</a>.
			</p>
		</section>


		<section class="info-prohibitions">
			<h2>{{ 'extrasSidebar.hazmat.text.exceptions' | ibeadmin | async }}</h2>

			<ul class="bullet-list">
				<li>
					<a class="link link--external link--advance-search" target="_blank" [attr.aria-label]="'extrasSidebar.hazmat.aria.goToWheelchairBatteriesInformation' | ibeadmin | async"
				href="http://www.flytap.com/USA/enus/PlanBook/PrepareforTravel/luggage/TransportLithiumBatteries" role="button">{{ 'extrasSidebar.hazmat.text.wheelchairBatteries' | ibeadmin | async }}</a>
				</li>
				<li>{{ 'extrasSidebar.hazmat.text.smallQuantities' | ibeadmin | async }}</li>
				<li>
					<a class="link link--external link--advance-search" target="_blank" [attr.aria-label]="'extrasSidebar.hazmat.aria.goToMedicalCases' | ibeadmin | async"
				href="http://www.flytap.com/USA/enus/PlanBook/PrepareforTravel/SpecialNeeds/MedicalCases" role="button">{{ 'extrasSidebar.hazmat.text.medicalCases' | ibeadmin | async }}</a>
				</li>
			</ul>
		</section>


		<div class="sidebar-flight-text border top-gap">
			<p><a class="link extras-feature__link" [attr.aria-label]="'extrasSidebar.hazmat.aria.closeDialog' | ibeadmin | async" (click)="INDRA_handleClose()" href="javascript:;"
					role="button">{{ 'extrasSidebar.hazmat.text.closeThisWindow' | ibeadmin | async }}</a></p>
		</div>

	</div>
</div>
